export const DELETE_WATCH_RULE_NAME = "delete_watch_rule" as const;

export const DELETE_WATCH_RULE_DESC =
  `Permanently deletes one Metric Watch rule.

Call list_watch_rules first, select exactly one rule, and copy its complete snapshot into rule. The user reviews that bound snapshot before approval. The backend delete remains ID-only and nonversioned.` as const;
